<template>
  <div class="modal-body--layers">
    <b-checkbox
      :checked="isAllSelected"
      @change="selectAllHandler"
    >
      Select All
    </b-checkbox>
    <FolderLayer
      v-for="template in templates"
      :key="template.name"
      :node="template"
    />
  </div>
</template>

<script>

import FolderLayer from "@frontend/components/modules/psd-layers/layer-views/FolderLayer.vue";
import { mapGetters } from 'vuex'

export default {
  name: "LayersTree",
  components: {FolderLayer},
  props: {
    templates: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    ...mapGetters('psdLayers', [
      'isAllSelected',
    ]),
  },
  methods: {
    selectAllHandler (selected) {
      this.$store.commit('psdLayers/TOGGLE_ALL', { selected })
    },
  },
}
</script>

<style scoped lang="scss">

</style>